/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 14:17:53
 * @Description: file content
 */
import React, { Component } from 'react';
import { Tooltip } from '@platform/base';
import './BtnItemTip.less';

export default class BtnItemTip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipStatus: false,
        }

        this.dom = React.createRef();
    }

    showTip = () => {
        let { btntip } = this.props; 
        if(btntip){// 有btntip鼠标放上去始终显示气泡，无论是否能显示全
            this.setState({ tipStatus: true });
        }else{
            let tipItem = this.dom.querySelector('.btn-item-left');
            if (tipItem && tipItem.clientWidth < tipItem.scrollWidth) {
                this.setState({ tipStatus: true });
            }
        }
    }

    closeTip = () => {
        this.setState({ tipStatus: false });
    }

    handleMouseOver = () => {
        this.showTip();
    }

    handleMouseLeave = () => {
        this.closeTip();
    }

    render() {
        let { className = '' } = this.props;
        className = 'component-buttonapp-tips ' + className;
        return (
            <Tooltip
                overlay={this.props.overlay}
                inverse
                delayShow={500}
                delay={1}
                visible={this.state.tipStatus}
                className={className}
            >
                <span 
                    onMouseOver={this.handleMouseOver}
                    onMouseLeave={this.handleMouseLeave}
                    ref={
                        dom => {
                            this.dom = dom;
                        }
                    }
                >
                    {this.props.children}
                </span>
            </Tooltip>
        );
    }
}
